/* ==========================================================================
   ML · Shared email gate. One unlocked state (localStorage) shared across:
   - Any [data-mlgate] link/button (Research downloads, Colouring Pages downloads,
     future free-book links)
   - The footer newsletter form (sets the same flag, so subscribers never see the gate)
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'ml_gate_unlocked';
  var SEND_TIMEOUT = 12000;

  function isUnlocked() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
  }
  function setUnlocked() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  var modal = document.getElementById('mlgate');
  if (!modal) return;

  /* The snippet is rendered inside the header loader, and Dawn's sticky header
     applies a CSS transform to that ancestor during scroll. Any transformed
     ancestor breaks position:fixed for descendants (a well-known CSS quirk),
     which silently collapses this modal to 0x0. Move it to <body> directly
     ("portal" pattern) so it never depends on any ancestor's positioning. */
  if (modal.parentNode !== document.body) document.body.appendChild(modal);

  var emailInput = document.getElementById('mlgate-email');
  var companyInput = document.getElementById('mlgate-company');
  var err = document.getElementById('mlgate-err');
  var submitBtn = document.getElementById('mlgate-submit');
  var shopForm = document.getElementById('mlgate-shopify-form');
  var pending = null; // { type: 'href'|'form', el, tag }
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    void modal.offsetWidth;
    modal.classList.add('is-open');
    document.addEventListener('keydown', onKey);
    setTimeout(function () { if (emailInput) emailInput.focus(); }, 50);
  }
  function close() {
    modal.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    document.documentElement.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-mlgate-close]') || e.target.classList.contains('mlgate__backdrop')) close();
  });

  function fetchLimited(url, opts, ms) {
    var ctrl = null, options = opts || {};
    if (window.AbortController) { try { ctrl = new AbortController(); options.signal = ctrl.signal; } catch (e) {} }
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return; settled = true;
        if (ctrl) { try { ctrl.abort(); } catch (e) {} }
        reject(new Error('timeout'));
      }, ms || SEND_TIMEOUT);
      fetch(url, options).then(function (r) {
        if (settled) return; settled = true; clearTimeout(timer); resolve(r);
      }, function (e) {
        if (settled) return; settled = true; clearTimeout(timer); reject(e);
      });
    });
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function proceed() {
    if (!pending) return;
    if (pending.type === 'href' && pending.href) {
      window.open(pending.href, '_blank');
    } else if (pending.type === 'form' && pending.el && pending.el.requestSubmit) {
      pending.el.requestSubmit();
    } else if (pending.type === 'form' && pending.el) {
      pending.el.submit();
    }
    pending = null;
  }

  function submit() {
    var email = (emailInput.value || '').trim();
    var honey = (companyInput.value || '').trim();
    if (!EMAIL_RE.test(email)) { err.textContent = 'Please enter a valid email address.'; return; }
    if (honey) { setUnlocked(); close(); proceed(); return; } // bot: silently succeed, no real submit
    err.textContent = '';
    submitBtn.disabled = true;
    submitBtn.textContent = 'Please wait...';

    var tag = (pending && pending.tag) || 'newsletter';

    var done = function () {
      setUnlocked();
      submitBtn.disabled = false;
      submitBtn.textContent = 'Get instant access';
      close();
      proceed();
    };

    if (!shopForm) { done(); return; }
    try {
      var fd = new FormData(shopForm);
      fd.set('contact[email]', email);
      fd.set('contact[tags]', tag);
      fetchLimited(shopForm.getAttribute('action') || '/contact', {
        method: 'POST', body: fd, headers: { 'Accept': 'text/html' }
      }, SEND_TIMEOUT).then(done, done); // proceed either way; never trap the user behind a network hiccup
    } catch (e) { done(); }
  }

  submitBtn.addEventListener('click', submit);
  emailInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') submit(); });

  /* ---------- triggers: any [data-mlgate] link or form ---------- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-mlgate]');
    if (!el) return;
    if (el.getAttribute('aria-disabled') === 'true') return;
    if (isUnlocked()) return; // already unlocked: let the normal click proceed
    e.preventDefault();
    pending = { type: 'href', href: el.getAttribute('href'), tag: el.getAttribute('data-mlgate-tag') };
    open();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.hasAttribute || !form.hasAttribute('data-mlgate-form')) return;
    if (isUnlocked()) return; // already unlocked: let the normal submit proceed
    e.preventDefault();
    pending = { type: 'form', el: form, tag: form.getAttribute('data-mlgate-tag') };
    open();
  });

  /* ---------- footer newsletter: submitting it also unlocks everything else ---------- */
  var footerForm = document.getElementById('mlfoot-news');
  if (footerForm) {
    footerForm.addEventListener('submit', function () { setUnlocked(); });
  }
  if (document.querySelector('.mlfoot__news-ok')) { setUnlocked(); } // landed back here after a successful subscribe
})();
